<template>
  <base-column :col="12" :colLg="6" class="mb-4">
      <base-row class="bg py-5">
        <div class="right w-50 text-end">
          <h1 class="right-head"><slot name="year"></slot></h1>
          <p class="right-header"><slot name="period"></slot></p>
        </div>
        <div class="left w-50">
          <h5 class="left-head"><slot name="function"></slot></h5>
          <span class="left-header"><slot name="company"></slot></span>
          <base-paragraph><slot name="description"></slot></base-paragraph>
        </div>
      </base-row>
  </base-column>

</template>

<script>
export default {
  name: "TheExperienceCover",
}
</script>

<style scoped>
.bg {
  margin-left: -30px;
  background-image: linear-gradient(90deg, white 30%,#f5f5f5 30%, #f5f5f5 100%);;
}
.bg:hover h1 {
  color: #f6483b;
  transform: scale(1.2);
}

.right-head {
  transition: all .3s;
  font-size: 6rem;
  margin: 0;
}

.right {
  z-index: 1;
}

.left-head {
  margin-bottom: 0;
}

.right-header {
  margin-top: -.7rem;
  font-weight: 700;
  color: #f6483b;
}

.left-header{
  color: black;
  font-weight: bold;
}
@media (max-width: 600px) {
  .right-head {
    font-size: 4rem;
  }
}
</style>